export type InvitationResult = { email: string; sent: boolean };
export type ContractWorkflow = {
  readiness: {
    ready: boolean;
    issues: string[];
    fields: {
      id: string;
      label: string;
      page: number;
      signer: string;
      required: boolean;
      issues: string[];
    }[];
  };
  recipients: {
    email: string;
    name: string;
    role: string;
    signed?: boolean;
    signed_at?: string;
    next_step: string;
    can_remind: boolean;
    invitation?: { email: string; sent: boolean | null };
  }[];
  events: {
    id: number;
    description: string;
    created_at: string;
    metadata: Record<string, any>;
  }[];
  events_limited: boolean;
  jobs: { id: number; name: string }[];
  final_pdf_available: boolean;
  evidence_available: boolean;
  document_hash: string;
};
export function invitationResults(payload: any): InvitationResult[] {
  return Array.isArray(payload?.results)
    ? payload.results.filter(
        (r: any) =>
          typeof r?.email === "string" && typeof r?.sent === "boolean",
      )
    : [];
}
export function invitationSummary(results: InvitationResult[]) {
  const accepted = results.filter((r) => r.sent).length;
  return `${accepted} of ${results.length} invitations accepted by the email provider${results.some((r) => !r.sent) ? "; some invitations failed." : "."}`;
}
